module.exports = __webpack_public_path__ + "img/concierge.f371dfa6.svg";